import React from "react";
import { Ban, ArrowRight } from "lucide-react";

/** v208 — "Discontinued, replaced by X" badge with optional jump button. */
const DiscontinuedBadge = ({ item, onUseReplacement, compact = false }) => {
  if (!item?.discontinued) return null;
  const name = item.replaced_by_name;
  return (
    <span
      data-testid={`discontinued-badge-${item.id}`}
      className={`inline-flex items-center flex-wrap gap-1.5 rounded border-2 border-[#8A1F1F] bg-[#FDE7EA] text-[#8A1F1F] font-bold ${
        compact ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-1"
      }`}
    >
      <Ban size={compact ? 10 : 12} strokeWidth={2.5} />
      {name ? `Discontinued, replaced by ${name}` : "Discontinued"}
      {onUseReplacement && item.replaced_by_id && name && (
        <button
          type="button"
          data-testid={`use-replacement-${item.id}`}
          onClick={(e) => {
            e.stopPropagation();
            onUseReplacement(item.replaced_by_id);
          }}
          className="inline-flex items-center gap-1 bg-[#8A1F1F] text-white rounded px-1.5 py-0.5 hover:bg-[#6E1717]"
        >
          Use {name} instead <ArrowRight size={11} strokeWidth={2.5} />
        </button>
      )}
    </span>
  );
};

export default DiscontinuedBadge;
